import "./index.scss";

import { Stack } from "@mui/material";
import moment from "moment";

const TimestampSummaryItem = ({ icon, title, date }) => {
  return (
    <Stack direction="row" className="timestamp-summary-item">
      <button>{icon}</button>
      <div>
        <p className="timestamp-summary-item__date">
          {date ? moment(date.toString()).format(`MM-DD-YYYY`).toString() : `N/A`}
        </p>
        <p className="timestamp-summary-item__title">{title}</p>
      </div>
    </Stack>
  );
};

export default TimestampSummaryItem;
